<template>
  <modal-auth modal-type="register" :data="data">
    <h5 class="text-center">{{$t('register')}}</h5>
    <br>
    <input type="text" class="form-control login-input" :placeholder="$t('yourFirstName')" v-model="data.firstName" required/>
    <input type="text" class="form-control login-input" :placeholder="$t('yourLastName')" v-model="data.lastName"/>
    <input type="email" class="form-control login-input mg-b5" :placeholder="$t('enterEmail')" v-model="data.email" required/>
    <label class="password-label">{{ $t('reg_password_label') }}</label>
    <input type="password" class="form-control login-input" :placeholder="$t('password')" v-model="data.password" required/>
    <input type="password" class="form-control login-input" :placeholder="$t('passwordConfirmation')" v-model="data.passwordConfirm" required/>
    <select class="form-control login-input" v-model="data.userType" required>
      <option class="option-select" value="" selected>{{ $t('reg_select_type') }}</option>
      <option value="artist">{{ $t('reg_artist_type') }}</option>
      <option value="agent">{{ $t('reg_agent_type') }}</option>
    </select>

    <div class="text-left">
      <div class="form-group has-label">
          <input type="checkbox" name="agreementCheckbox" id="youtubeRadio" v-model="data.isAgreementAccepted" required/>
          <label class="form-checkbox" for="youtubeRadio">
            <span>
             {{ $t('reg_agreement') }} 
             <router-link :to="{name: 'termsAndCondition'}" target="_blank" class="link">{{ $t('reg_agreement_part') }}</router-link>
             {{ $t('and') }} 
             <router-link :to="{name: 'privacyPolicy'}" target="_blank" class="link">{{ $t('reg_privacy_policy') }}</router-link>
             universtage.com
             <span class="require-sign">*</span>
            </span>
          </label>
      </div>
    </div>

    <div class="text-center">
      <button v-if="!isLoading" class="btn btn-fill btn-danger btn-round btn-sm btn-wd full-width btn-register" type="submit">{{$t('createAccount')}}</button>
      <sync-loader v-if="isLoading" class="text-center" color="red"></sync-loader>
    </div>

    <div class="text-center reg-btns">

      <google-sign-in-button @click="authGoogle()"/>
    </div>
  </modal-auth>
</template>

<script>
  import ModalAuth from '../components/ModalAuth'
  import GoogleSignInButton from '../components/GoogleSignInButton'
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        data: {
          email: '',
          password: '',
          passwordConfirm: '',
          firstName: '',
          lastName: '',
          userType: '',
          userCategory: '',
          isAgreementAccepted: false
        },
        loopbackBase: process.env.VUE_APP_USTAGE_BASE || 'http://localhost:3000' 
      }
    },
    computed: {
      ...mapGetters(['isLoading'])
    },
    methods: {
      authGoogle() {
         window.open(this.loopbackBase + '/auth/google', '_self');
      }
    },
    components: { ModalAuth, GoogleSignInButton, syncLoader },
  }
</script>

<style scoped>
.form-checkbox {
    font-size: 20px !important;
}
.form-checkbox span {
  font-size: 0.8rem;
  line-height: 1.2;
  color: black;
  padding-left: 5px;
  padding-right: 15px;
  display: inline-block;
  position: absolute;
}
.form-checkbox span a {
  color: black !important;
  text-decoration: underline;
  font-size: 0.8rem;
}
.btn-register {
  margin-top: 20px;
}
div.form-group.has-label {
  margin-bottom: 0 !important;
}
.require-sign {
  color: red !important;
}
.password-label {
  color: black !important;
  font-size: 0.8rem !important;
  line-height: 1.2;
}
.mg-b5 {
  margin-bottom: 5px !important;
}
.reg-btns {
  margin-top: 15px;
}
</style>
